export default "__VITE_ASSET__O0ah_OK6__"